/**
 * Crea los valores de todas las variables simples
 * @param {*} scene - Escena actual de Phaser
 */
export function crearVariables(scene) {

  scene.apuestaTotal = 0; // Apuesta total del jugador al iniciar la ruleta
  scene.premioTotal = 0; // Premio total del jugador al finalizar la ruleta
  scene.noVaMas = false; // Indica si no se aceptan movimiento de fichas
  scene.imagenesNumerosApuesta = []; // Arreglo que guarda las imagenes(números) de la Apuesta Total
  scene.imagenesNumerosPremio = []; // Arreglo que guarda las imagenes(números) del Premio Total

  scene.ultimaFilaActualCol1 = 4; // Guarda la fila que es la última actualmente
  scene.ultimaFilaActualCol2 = 4; // Guarda la fila que es la última actualmente
  scene.ultimaFilaActualCol3 = 4; // Guarda la fila que es la última actualmente
  scene.ultimaFilaActualCol4 = 4; // Guarda la fila que es la última actualmente
  scene.ultimaFilaActualCol5 = 4; // Guarda la fila que es la última actualmente
}